import {
    Grid,
    InputAdornment,
    TableBody,
    TableCell,
    TableRow,
    Toolbar,
    Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { AiOutlineCheck, AiOutlineSearch } from "react-icons/ai";
import { IoMdAdd } from "react-icons/io";
import Controls from "../../components/controls/Controls";
import Notify from "../../components/customHelpers/Notify";
import Popup from "../../components/customHelpers/Popup";
import JobForm from "../../components/forms/JobForm";
import JobDetails from "../../components/JobDetails";
import Jobs from "../../actions/Jobs";
import useTable from "../../components/customHelpers/useTable";
import { MdOutlineDelete, MdClose } from "react-icons/md";
import { FiEdit, FiEye, FiArrowLeft } from "react-icons/fi";
import Layout from "../../components/layout/Layout";
import Admin from "../../components/auth/Admin";
import Loading from "../../components/customHelpers/Loading";
import Norecords from "../../components/customHelpers/Norecords";
import Notification from "../../components/customHelpers/Notification";
import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";

const headCells = [
    { id: "title", label: "Title" },
    { id: "company", label: "Company" },
    { id: "status", label: "Status" },
    { id: "createdAt", label: "Posted At" },
    { id: "actions", label: "Actions", disableSorting: true },
];

const makeData = (result) => {
    return result.map((data) => {
        return {
            title: data.Title || data.title,
            Id: data.Id,
            body: data.Body || data.body,
            company: data.Company?.name || data.Author || data.author,
            createdAt: data.createdAt,
            status: data.status || "pending",
        };
    });
};

const JobRequests = () => {
    const { deleteJob, getUserJobs, adminApproveJob, approveJob, rejectJob, getAllJobsForAdmin } = Jobs();
    const [openPopup, setOpenPopup] = useState(false);
    const { NotifyMessage, notify, setNotify } = Notify();
    const [recordForEdit, setRecordForEdit] = useState(null);
    const [isViewMode, setIsViewMode] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
    });

    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });
    const [values, setValues] = useState({
        loading: false,
        jobs: [],
        reload: false,
    });
    const { loading, jobs, reload } = values;

    useEffect(() => {
        getAllJobRequests();
    }, [reload]);

    const getAllJobRequests = () => {
        setValues({
            ...values,
            loading: true,
        });
        getAllJobsForAdmin().then((data) => {
            if (data.err) {
                NotifyMessage({
                    message: data.err,
                    type: "error",
                });
                setValues({ ...values, loading: false });
            } else {
                setValues({
                    ...values,
                    jobs: makeData(data.result || []),
                    loading: false,
                });
            }
        });
    };

    const handleSearch = (e) => {
        e.target.value = e.target.value.trimLeft();
        let target = e.target;
        setFilterFn({
            fn: (items) => {
                const columns = ["title", "company"];
                if (target.value == "") return items;
                else {
                    return items.filter((x) => {
                        return columns.some((column) => {
                            return (
                                x[column]
                                    ?.toString()
                                    .toLowerCase()
                                    .indexOf(target.value.toLowerCase()) > -1
                            );
                        });
                    });
                }
            },
        });
    };

    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
        useTable(
            jobs.sort((a, b) =>
                a.createdAt < b.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : 0
            ),
            headCells,
            filterFn
        );

    const onReject = (Id) => {
        setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
        });
        setOpenPopup(false);

        rejectJob(Id).then((data) => {
            if (data.err) {
                NotifyMessage({
                    message: data.err,
                    type: "error",
                });
            } else {
                NotifyMessage({
                    message: data.message,
                    type: "success",
                });
                setValues({ ...values, reload: !reload });
            }
        });
    };

    const onApprove = (Id) => {
        setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
        });
        setOpenPopup(false);

        approveJob(Id).then((data) => {
            if (data.err) {
                NotifyMessage({
                    message: data.err,
                    type: "error",
                });
            } else {
                NotifyMessage({
                    message: data.message,
                    type: "success",
                });
                setValues({ ...values, reload: !reload });
            }
        });
    };

    const StatusBadge = ({ status }) => {
        const getColor = () => {
            switch (status) {
                case "approved":
                    return "#4caf50";
                case "rejected":
                    return "#f44336";
                default:
                    return "#ff9800";
            }
        };

        return (
            <span
                style={{
                    padding: "4px 12px",
                    borderRadius: "12px",
                    backgroundColor: getColor(),
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                }}
            >
                {status || "pending"}
            </span>
        );
    };

    return (
        <Layout>
            <Admin>
                <div>
                    <Grid container alignItems="center" style={{ marginBottom: "20px" }}>
                        <Grid item xs={6}>
                            <Controls.Button
                                text="Back to Dashboard"
                                startIcon={<FiArrowLeft />}
                                onClick={() => window.history.back()}
                                variant="outlined"
                                color="default"
                            />
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: "right" }}>
                            <Typography variant="h6" className="page-header">
                                Manage Job Posts
                            </Typography>
                        </Grid>
                    </Grid>
                    <Toolbar>
                        <Controls.Input
                            label="Search Requests"
                            className="searchInput"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <AiOutlineSearch />
                                    </InputAdornment>
                                ),
                            }}
                            onChange={handleSearch}
                        />
                    </Toolbar>
                    <Grid container>
                        <Grid item xs={12} className="card__body">
                            {loading ? (
                                <Loading />
                            ) : (
                                <>
                                    <TblContainer>
                                        <TblHead />
                                        <TableBody>
                                            {recordsAfterPagingAndSorting().length > 0 ? (
                                                recordsAfterPagingAndSorting().map((item) => (
                                                    <TableRow key={item.Id}>
                                                        <TableCell>{item.title}</TableCell>
                                                        <TableCell>{item.company}</TableCell>
                                                        <TableCell>
                                                            <StatusBadge status={item.status} />
                                                        </TableCell>
                                                        <TableCell>
                                                            {new Date(item.createdAt).toLocaleString()}
                                                        </TableCell>
                                                        <TableCell>
                                                            <Controls.ActionButton
                                                                color="primary"
                                                                title="View"
                                                                onClick={() => {
                                                                    setRecordForEdit(item);
                                                                    setIsViewMode(true);
                                                                    setOpenPopup(true);
                                                                }}
                                                            >
                                                                <FiEye fontSize="medium" />
                                                            </Controls.ActionButton>
                                                            <Controls.ActionButton
                                                                color="primary"
                                                                title="Approve"
                                                                disabled={item.status === "approved"}
                                                                onClick={() => {
                                                                    setConfirmDialog({
                                                                        isOpen: true,
                                                                        title: "Are you sure to approve this job post?",
                                                                        subTitle: "It will be marked as Approved.",
                                                                        onConfirm: () => {
                                                                            onApprove(item.Id);
                                                                        },
                                                                    });
                                                                }}
                                                            >
                                                                <AiOutlineCheck fontSize="medium" />
                                                            </Controls.ActionButton>
                                                            <Controls.ActionButton
                                                                color="secondary"
                                                                title="Reject"
                                                                disabled={item.status === "rejected"}
                                                                onClick={() => {
                                                                    setConfirmDialog({
                                                                        isOpen: true,
                                                                        title: "Are you sure to reject this job post?",
                                                                        subTitle: "It will be marked as Rejected.",
                                                                        onConfirm: () => {
                                                                            onReject(item.Id);
                                                                        },
                                                                    });
                                                                }}
                                                            >
                                                                <MdClose fontSize="medium" />
                                                            </Controls.ActionButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <Norecords col={6} />
                                            )}
                                        </TableBody>
                                    </TblContainer>
                                    <TblPagination />
                                </>
                            )}
                        </Grid>
                    </Grid>
                    <Popup
                        title={isViewMode ? "Job Details" : "Job Form"}
                        openPopup={openPopup}
                        setOpenPopup={setOpenPopup}
                    >
                        {isViewMode ? (
                            <JobDetails
                                record={recordForEdit}
                                onApprove={(Id) => {
                                    setConfirmDialog({
                                        isOpen: true,
                                        title: "Are you sure to approve this job post?",
                                        subTitle: "It will be marked as Approved.",
                                        onConfirm: () => {
                                            onApprove(Id);
                                        },
                                    });
                                }}
                                onDelete={(Id) => {
                                    setConfirmDialog({
                                        isOpen: true,
                                        title: "Are you sure to reject this job request?",
                                        subTitle: "This action will mark the job post as rejected.",
                                        onConfirm: () => {
                                            onReject(Id);
                                        },
                                    });
                                }}
                                onClose={() => setOpenPopup(false)}
                            />
                        ) : (
                            <JobForm
                                recordForEdit={recordForEdit}
                                NotifyMessage={NotifyMessage}
                                getAllJobs={getAllJobRequests}
                                setOpenPopup={setOpenPopup}
                            />
                        )}
                    </Popup>
                    <Notification notify={notify} setNotify={setNotify} />
                    <ConfirmDialog
                        confirmDialog={confirmDialog}
                        setConfirmDialog={setConfirmDialog}
                    />
                </div>
            </Admin>
        </Layout>
    );
};

export default JobRequests;
